//$(document).ready(function () {

     
//    $(".CurrencyItem").live("click", function () {

//        $(".CurrencyItem").removeClass("active");
//        $(this).addClass("active");

//    });

//    var currencyID = $('input[name=currencyID]:checked').val();

//    if (currencyID == undefined || currencyID == null)
//    {
//        $(".CurrencyItem").first().find(".currencyID").attr("checked", "checked");
//        $(".CurrencyItem").first().addClass("active");
//    }

//    $(document).on("click", "#CurrencySelectFromBar", function (e) {

//        var hs = window.location.hash;
//        hs = hs.replace("=", "[_]");
//        hs = hs.replace("&", "[and]")
        

       

//        $.ajax({
//            type: 'get',
//            url: '/Home/ChangeCurrency',
//            data: 'Url=' + $("#Url").val() + "&currencyID=" + $('input[name=currencyID]:checked').val() + "&hash=" + window.location.hash + "&countryCode=" + $("#CountryCode").val(),
//            success: function (dt) {

//                //window.location.reload(true);
//               window.parent.location.href = dt;

//            }
//        });


//    });


//});

$(document).ready(function () {


    $(".CurrencyItem").live("click", function () {

        $(".CurrencyItem").removeClass("active");
        $(this).addClass("active");

    });

    var currencyID = $('input[name=currencyID]:checked').val();

    if (currencyID == undefined || currencyID == null) {
        $(".CurrencyItem").first().find(".currencyID").attr("checked", "checked");
        $(".CurrencyItem").first().addClass("active");
    }

    $(document).on("click", "#CurrencySelectFromBar", function (e) {

        var hs = window.location.hash;
        hs = hs.replace("=", "[_]");
        hs = hs.replace("&", "[and]")

        var langCode = $("#SmallLangCode").val();

        $.ajax({
            type: 'get',
            url: '/Home/ChangeCurrency',
            data: 'Url=' + $("#Url").val() + "&currencyID=" + $('input[name=currencyID]:checked').val() + "&hash=" + window.location.hash + "&countryCode=" + $("#CountryCode").val(),
            success: function (dt) {

                //window.location.reload(true);
                //window.parent.location.href = dt;
                window.parent.location.href = "/" + langCode;

            }
        });

    });

    $(".LangOptions .LngItem").live("click", function (e) {

        var langID = $(this).attr("data-id");
        var langCode = $(this).attr("data-langcode");
        changeSiteLanguage(langID, langCode);
        return false;
        e.preventDefault();
    });
});

function changeSiteLanguage(langID, langCode) {

    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    $.ajax({
        type: 'get',
        url: '/Home/ChangePageLang',
        data: 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode,
        success: function (dt) {
            window.parent.location.href = dt;
        }
    });

}
